import { render, staticRenderFns } from "./ChinaStockWatchlist.vue?vue&type=template&id=384fbe4b&scoped=true"
import script from "./ChinaStockWatchlist.vue?vue&type=script&lang=js"
export * from "./ChinaStockWatchlist.vue?vue&type=script&lang=js"
import style0 from "./ChinaStockWatchlist.vue?vue&type=style&index=0&id=384fbe4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384fbe4b",
  null
  
)

export default component.exports